import React from 'react';
import { useLiveChatBackdropStyles } from './useLiveChatBackdropStyles';
export const LivechatBackdrop = (props) => {
    const classes = useLiveChatBackdropStyles();
    return (React.createElement("div", { onMouseUp: props.onStopDragging, onMouseMove: props.onDrag, role: "presentation", className: classes['livechat-back-drop'] }));
};
